import { text } from '#contract'
import { useClient } from '../../app/client-context.ts'
import { useView } from '../../app/use-view.ts'
import { SettingRow } from '../../components/setting-row.tsx'
import { Toggle } from '../../components/toggle.tsx'
import { useT } from '../../i18n/index.ts'
import { ResetSection } from './reset-section.tsx'
import styles from './settings-screen.module.css'

/** Subtitles and reduced motion. Both take effect immediately. */
export function AccessibilityTab() {
  const t = useT()
  const client = useClient()
  const accessibility = useView((view) => view.settings.accessibility)

  return (
    <div class={styles.stack}>
      <SettingRow label={t(text('settings.accessibility.subtitles'))}>
        <Toggle
          checked={accessibility.subtitles}
          onChange={(subtitles) => {
            client?.updateSettings({ accessibility: { subtitles } })
          }}
        />
      </SettingRow>
      <SettingRow
        label={t(text('settings.accessibility.reducedMotion'))}
        description={t(text('settings.accessibility.reducedMotion.description'))}
      >
        <Toggle
          checked={accessibility.reducedMotion}
          onChange={(reducedMotion) => {
            client?.updateSettings({ accessibility: { reducedMotion } })
          }}
        />
      </SettingRow>
      <ResetSection section="accessibility" />
    </div>
  )
}
